import { FormSelect, Option } from './FormSelect';
FormSelect.Option = Option;
export default FormSelect;
